import React, { useEffect } from 'react';
import { BaseFormField } from './BaseFormField';
import PhoneCodeDropdown from '../dropdown/phoneCode';

interface PhoneInputProps {
    countryCodeName: string;
    phoneName: string;
    label: string;
    required?: boolean;
    disabled?: boolean;
    onPhoneError: (error: string) => void;
    onValueChange?: (value: string, values: any) => void;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({
    countryCodeName,
    phoneName,
    label,
    required = false,
    disabled = false,
    onPhoneError,
    onValueChange,
}) => {
    return (
        <div className="mb-4">
            <label className="fs-14 fw-400 mb-2">
                {label} {required && <span className="lt-text-error">*</span>}
            </label>
            <div className="d-flex">
                <BaseFormField name={countryCodeName}>
                    {(props) => <CountryCodeInput disabled={disabled} {...props} onValueChange={onValueChange} />}
                </BaseFormField>

                <BaseFormField name={phoneName}>
                    {(props) => (
                        <PhoneNumberInput
                            disabled={disabled}
                            {...props}
                            onPhoneError={onPhoneError}
                            onValueChange={onValueChange}
                        />
                    )}
                </BaseFormField>
            </div>
        </div>
    );
};

const PhoneNumberInput: React.FC<any> = ({
    field,
    error,
    values,
    setFieldValue,
    setFieldTouched,
    onPhoneError,
    onValueChange,
    disabled,
}) => {
    useEffect(() => {
        onPhoneError(error ? error.toString() : '');
    }, [error]);

    const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const regex = /^\d+$/;
        if (regex.test(ev.target.value) || ev.target.value === '') {
            setFieldTouched(field.name);
            setFieldValue(field.name, ev.target.value);
            onValueChange?.(ev.target.value, { ...values, [field.name]: ev.target.value });
        }
    };

    return (
        <input
            type="text"
            value={field.value || ''}
            onChange={handleChange}
            disabled={disabled}
            className={`form-control form-phone-border ${error ? 'phone-input is-invalid' : ''}`}
            placeholder="Enter Contact Number"
            maxLength={10}
        />
    );
};

const CountryCodeInput: React.FC<any> = ({ field, setFieldValue, onValueChange, disabled }) => {
    return (
        <PhoneCodeDropdown
            id="candidate"
            disabled={disabled}
            candidateValue={field.value}
            setFieldValue={setFieldValue}
            onPhoneCodeSelectionChange={(code: string) => onValueChange?.(code, { [field.name]: code })}
        />
    );
};
